import { trackEvent } from '~/shared/lib/analytics'
import { DOCUMENT_REVIEW_STARTED } from '../config'
import { getSecSinceLastCompletion } from './storage'

export function trackQueueSelected(documentKey: string) {
  trackEvent(DOCUMENT_REVIEW_STARTED, {
    document_key: documentKey,
    sec_since_last_completion: getSecSinceLastCompletion(),
  })
}
